// FEATURES BUNDLE - Optional functionality loaded after core
// Can load deferred since it handles non-critical features
import { Testimonials } from "./components/testimonials";
import { InvestmentsBlock } from "./components/investments";
import { MapBlock } from "./components/map";
import { WholesalerMapBlock } from "./components/wholesaler-map";

// Custom HTML sanitizer to prevent XSS
function sanitizeHTML(html) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  
  // Remove dangerous tags
  const dangerousTags = [
    'script', 'iframe', 'object', 'embed', 'link', 'style', 'form',
    'input', 'textarea', 'button', 'select', 'option', 'base', 
    'meta', 'applet', 'svg', 'math', 'template', 'audio', 'video'
  ];
  dangerousTags.forEach(tag => {
    const elements = doc.querySelectorAll(tag);
    elements.forEach(el => el.remove());
  });
  
  // Remove dangerous attributes from all elements
  const allElements = doc.querySelectorAll('*');
  const dangerousProtocols = /^[\s\0]*(?:javascript|data|vbscript|file|about):/i;
  
  allElements.forEach(el => {
    Array.from(el.attributes).forEach(attr => {
      const attrName = attr.name.toLowerCase();
      const attrValue = attr.value.toLowerCase().trim();
      
      // Remove event handlers (onclick, onload, onerror, etc.)
      if (attrName.startsWith('on')) {
        el.removeAttribute(attr.name);
        return;
      }
      
      // Remove dangerous attributes
      if (['formaction', 'form', 'action', 'srcdoc', 'sandbox'].includes(attrName)) {
        el.removeAttribute(attr.name);
        return;
      }
      
      // Remove dangerous protocols in href, src, data, etc.
      if (attr.value) {
        const decodedValue = decodeURIComponent(attr.value).replace(/[\s\0]/g, '');
        if (dangerousProtocols.test(decodedValue)) {
          el.removeAttribute(attr.name);
        }
      }
    });
  });
  
  const sanitized = doc.body.innerHTML;
  
  // Additional check: ensure no script tags slipped through
  if (/<script/i.test(sanitized)) {
    console.warn('Potential XSS attempt blocked');
    return '';
  }
  
  return sanitized;
}

  Testimonials();
  InvestmentsBlock();
  MapBlock();
  WholesalerMapBlock();

// Lazy load cards with Intersection Observer
const lazyLoad = () => {
  const cards = document.querySelectorAll(".card");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.5 }
  );

  cards.forEach((card) => {
    observer.observe(card);
  });
};

// Article filtering functionality - only on /learn/ page
document.addEventListener('DOMContentLoaded', () => {
  const filterButtons = document.querySelectorAll('#learn__filter button');
  const sortDropdown = document.getElementById('learn__filter__date');
  const tagDropdown = document.getElementById('learn__tag');
  const cardsContainer = document.getElementById('cards-container');

  if (!cardsContainer) return; // Skip if not on learn page

  const fetchArticles = () => {
    const selectedCategory = document.querySelector('#learn__filter button.active')?.dataset.category || '';
    const selectedSortOrder = sortDropdown ? sortDropdown.value : '';
    const selctedTagDropdown = tagDropdown ? tagDropdown.value : '';
    const urlParams = new URLSearchParams(window.location.search);
    const selectedAuthor = urlParams.get('author') || '';

    const formData = new FormData();
    formData.append('action', 'filter_articles');
    formData.append('category', selectedCategory);
    formData.append('sort_order', selectedSortOrder);
    formData.append('tag', selctedTagDropdown);
    formData.append('author', selectedAuthor);

    fetch(myAjax.ajaxurl, {
      method: 'POST',
      body: formData
    })
    .then(response => response.text())
    .then(data => {
      cardsContainer.innerHTML = sanitizeHTML(data);
      lazyLoad();
    })
    .catch(error => console.error('Error:', error));
  };

  filterButtons.forEach(button => {
    button.addEventListener('click', () => {
      filterButtons.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');
      fetchArticles();
    });
  });

  if (sortDropdown) {
    sortDropdown.addEventListener('change', fetchArticles);
    tagDropdown.addEventListener('change', fetchArticles);
  }

  fetchArticles();
});

// Accordion functionality - UU-18493
document.addEventListener('DOMContentLoaded', () => {
  const accordionItems = document.querySelectorAll('.accordion-item');
  
  if (accordionItems.length > 0) {
    accordionItems.forEach(item => {
      const collapseDiv = item.querySelector('.accordion-collapse');
      
      if (collapseDiv) {
        function updateOpenClass() {
          if (collapseDiv.classList.contains('show')) {
            item.classList.add('open');
          } else {
            item.classList.remove('open');
          }
        }

        updateOpenClass();
        
        collapseDiv.addEventListener('shown.bs.collapse', function() {
          item.classList.add('open');
        });
        
        collapseDiv.addEventListener('hidden.bs.collapse', function() {
          item.classList.remove('open');
        });
      }
    });
  }
});

// Form navigation scroll - UU-19532
document.addEventListener('click', function(event) {
  // Check for both next and previous buttons
  if (event.target.closest('.gform_next_button') || event.target.closest('.gform_previous_button')) {
    setTimeout(function() {
      var modal = document.querySelector('.modal.show');
      var modalBody = document.querySelector('.modal.show .modal-body');

      // Try multiple scroll approaches
      if (modal) {
        modal.scrollTop = 0;
      }
      if (modalBody) {
        modalBody.scrollTop = 0;
        modalBody.style.scrollBehavior = 'auto';
        modalBody.scrollTop = 0;
      }
    }, 300);
  }
});

// Initialize lazy load on page load
window.addEventListener('load', lazyLoad);